<template lang="pug">
  Default(
    :footer='false'
  )
</template>

<script>
import showSidebar from "@/mixins/shared/showSidebar.mixin";
import Default from "@/layouts/Default";

export default {
  mixins: [showSidebar],
  components: {
    Default
  },
  beforeRouteEnter(to, from, next) {
    next(component => {
      component.$router.push("/").catch(() => {});
    });
  }
};
</script>

<style></style>
